import React from 'react';
import { registerWidget } from '../widgetRegistry';
import { useLayoutCtx } from '../LayoutContext';

// Granular Add-Case widget — Cancel / Pick-different-type / Create case.
// Reads validity state (form.title non-empty + busy flag) from
// useLayoutCtx().draft, fires the host-supplied callbacks for submit /
// cancel / back-to-picker.

const btnPrimary = { background: 'var(--accent-color)', color: '#fff', border: 'none', borderRadius: '6px', padding: '7px 14px', cursor: 'pointer', fontWeight: 600, fontSize: '13px' };
const btnSecondary = { background: 'var(--bg-tertiary)', color: 'var(--text-primary)', border: '1px solid var(--border-color)', borderRadius: '6px', padding: '7px 14px', cursor: 'pointer', fontSize: '13px' };

function AddCaseToolbar({ config }) {
  const { draft, callbacks, bus } = useLayoutCtx();
  const form = draft?.form || {};
  const busy = !!draft?.busy;
  const showBack = config.show_pick_different !== false;
  const showCancel = config.show_cancel !== false;
  const submitLabel = config.submit_label || 'Create case';
  const titleValid = !!(form.title && form.title.trim());

  const fire = (name, value) => {
    if (callbacks && typeof callbacks[name] === 'function') callbacks[name](value);
    if (bus && typeof bus.publish === 'function') {
      const topic = name === 'onSubmit' ? 'xv.AddCaseSubmitted' : name === 'onCancel' ? 'xv.AddCaseCancelled' : 'xv.AddCaseBack';
      bus.publish(topic, { draft });
    }
  };

  return (
    <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: '14px', paddingTop: '12px', borderTop: '1px solid var(--border-color)' }}>
      {showBack && (
        <button onClick={() => fire('onPickAgain')} disabled={busy} style={btnSecondary}>← Pick different type</button>
      )}
      {showCancel && (
        <button onClick={() => fire('onCancel')} disabled={busy} style={btnSecondary}>Cancel</button>
      )}
      <button onClick={() => fire('onSubmit')} disabled={busy || !titleValid} style={btnPrimary}>
        {busy ? 'Creating…' : submitLabel}
      </button>
    </div>
  );
}

registerWidget({
  type: 'add_case.toolbar',
  categories: ['add_case'],
  palette_label: 'Add Case toolbar',
  description: 'Cancel / Pick-different-type / Create case action row. Fires onSubmit / onCancel / onPickAgain on the host modal.',
  Component: AddCaseToolbar,
  configSchema: {
    fields: [
      { type: 'boolean', name: 'show_pick_different', label: 'Show "← Pick different type"', default: true },
      { type: 'boolean', name: 'show_cancel', label: 'Show "Cancel"', default: true },
      { type: 'text', name: 'submit_label', label: 'Submit button label', default: 'Create case' },
    ],
  },
  publishes: ['xv.AddCaseSubmitted', 'xv.AddCaseCancelled', 'xv.AddCaseBack'],
  subscribes: [],
  group: 'Add Case',
});
